import { memo } from "react";
import { Skeleton } from "@/app/components/shadcn/skeleton";
import ProductCardSkeleton from "./ProductCardSkeleton";

const ProductSectionSkeleton = () => {
  return (
    <section className="bg-linear-to-b from-muted border border-muted to-white p-2 sm:p-4 rounded-md">
      <div className="flex items-center justify-between mb-2 sm:mb-3">
        <Skeleton className="h-6 sm:h-7 w-40 sm:w-52" />
        <Skeleton className="h-5 sm:h-6 w-24 sm:w-32" />
      </div>

      <div className="flex gap-2 sm:gap-3">
          <div className="flex-1"><ProductCardSkeleton /></div>
          <div className="flex-1"><ProductCardSkeleton /></div>
          <div className="flex-1 hidden sm:block"><ProductCardSkeleton /></div>
          <div className="flex-1 hidden md:block"><ProductCardSkeleton /></div>
          <div className="flex-1 hidden lg:block"><ProductCardSkeleton /></div>
          <div className="flex-1 hidden xl:block"><ProductCardSkeleton /></div>
        </div>
    </section>
  );
};

export default memo(ProductSectionSkeleton);